export default "__VITE_ASSET__NoIOVx2g__"